export class LocalStorageConstants {
  static readonly LS_ISSUER_URI = "authorization.service.issuer_uri";
  static readonly LS_USER_INFO = "authorization.service.user_info";
  static readonly LS_OPENID_CONFIG =
    "authorization.service.parsed_openid_configuration";
  static readonly LS_TOKEN_RESPONSE = "authorization.service.token_response";
}
